export default __webpack_public_path__ + "static/media/marauders-map-v5.0-gallery-02.54a0350a.jpg";